<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path d="m11.25 7.2.711-1.548L13.5 4.95l-1.539-.702L11.25 2.7l-.684 1.548L9 4.95l1.566.702.684 1.548ZM3.6 9l.36-1.44L5.4 7.2l-1.44-.36L3.6 5.4l-.36 1.44-1.44.36 1.44.36L3.6 9Z"/>
    <path d="M14.85 5.4c-.963 0-1.656 1.008-1.215 1.926l-2.709 2.709a1.327 1.327 0 0 0-1.161 0l-.909-.91c.09-.17.144-.368.144-.575 0-.747-.603-1.35-1.35-1.35-.747 0-1.35.603-1.35 1.35 0 .207.054.405.135.576l-2.709 2.709a1.356 1.356 0 0 0-.576-.135c-.747 0-1.35.603-1.35 1.35 0 .747.603 1.35 1.35 1.35.747 0 1.35-.603 1.35-1.35 0-.207-.054-.405-.135-.576l2.709-2.709c.468.225.891.126 1.161 0l.909.909c-.09.171-.144.369-.144.576 0 .747.603 1.35 1.35 1.35.747 0 1.35-.603 1.35-1.35 0-.207-.054-.405-.135-.576l2.709-2.709c.927.45 1.926-.261 1.926-1.215 0-.747-.603-1.35-1.35-1.35Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
